const pages = {
    'general-settings': {
        title: 'General Settings'
    },
    'stream-criteria': {
        title: 'Stream Criteria'
    },
    'search-criteria': {
        title: 'Search Criteria'
    },
    'local-documents': {
        title: 'Documents'
    },
    'url-management': {
        title: 'URL Management'
    },
    'scraping-rules': {
        title: 'Scraping Rules'
    },
    'crawler-settings': {
        title: 'Crawler Settings'
    },
    'ecm-crawler-settings': {
        title: 'ECM Crawler Settings'
    },
    'ecm-annotation-settings': {
        title: 'Annotation'
    },
    'rdbms-crawler-settings': {
        title: 'RDBMS Crawler Settings'
    },
    'scheduling': {
        title: 'Scheduling'
    },
    'edit-scraping-rule': {
        title: 'Edit Scraping Rule'
    },
    'general-configs' :{
        title: 'Integration'
    },
    'folders' :{
        title: 'Folders'
    },
    'advanced-config' :{
        title: 'Other'
    },
    'utilities-monitoring':{
        title: 'Monitoring'
    },
    'dashboard-notification':{
        title: 'Event Notification Service'
    },
    'ecm-repo-general':{
        title: 'General'
    },
    'ecm-repo-connections':{
        title: 'ECM Connections'
    },
    'ecm-repo-partitions':{
        title: 'Partitions'
    },
    'ecm-repo-folders':{
        title: 'Excluded Folders'
    },
    'reports-exec':{
        title: 'Last Execution Status'
    },
    'reports-error':{
        title:'Warnings\\Errors'
    },
    'reports-history':{
        title:'History'
    },
    'reports-document':{
        title:'Document Status'
    },
    'reports-queue':{
        title:'Queue Status'
    },
    'ecm-repo-import':{
        title: 'Import ECM Repository Configuration'
    },
    'rdbms-repo-general':{
        title: 'General'
    },
    'rdbms-repo-connections':{
        title: 'RDBMS Connection'
    },
    'rdbms-repo-partitions':{
        title: 'Partitions'
    },
    'reports-exec-rdbms':{
        title: 'Last Execution Status'
    },
    'reports-error-rdbms':{
        title:'Warnings\\Errors'
    },
    'reports-history-rdbms':{
        title:'History'
    },
    'reports-document-rdbms':{
        title:'Document Status'
    },
    'reports-queue-rdbms':{
        title:'Queue Status'
    },
};

export default pages;
